export const formatTime = (time) => {
  const date = new Date(time);
  const now = new Date();
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);

  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

  // 今天的数据显示 10:30 AM 格式
  if (date >= today) {
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  }

  // 昨天的数据显示 Yesterday, 10:30 AM 格式
  if (date >= yesterday && date < today) {
    return `Yesterday, ${date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })}`;
  }

  // 7天前的数据显示 October 22, 10:30 AM 格式
  if (date >= sevenDaysAgo && date < yesterday) {
    return `${date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
    })}, ${date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })}`;
  }

  // 30天前的数据显示 October 22, 2020 格式
  return `${date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
  })}, ${date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  })}`;
  // return date.toLocaleDateString('en-US', {
  //   year: 'numeric',
  //   month: 'long',
  //   day: 'numeric'
  // });
};

export function transFormOccupancy(occupancy) {
	switch (occupancy) {
		case "PRIMARY":
			return "principal"
		case "SECOND_HOME":
			return "secondhome"
		case "INVESTMENT":
			return "investment"
		default:
			alert("wrong occupancy")
			return "PRIMARY"
	}
}

export function transFormPropertyType(propertytype) {
	const remap = {
		"CONDOMINIUM_DETACHED": "condominiumdetached",
		"CONDOMINIUM_ATTACHED": "condominium",
		"PUD_ATTACHED": "pudattached",
		"PUD_DETACHED": "puddetached",
		"SINGLE_FAMILY_ATTACHED": "singlefamilyattached",
		"SINGLE_FAMILY_DETACHED": "singlefamilydetached",
		"TWO_TO_FOUR_FAMILY": "twotofourfamily",
		"MANUFACTURED_HOME": "manufacturedhome"
	}
	const out = remap[propertytype]
	return out
}
